export default __webpack_public_path__ + "static/char-thumb-21-10b82d75a2840ee08cc5d3c5a41229a5.webp";